module.exports = __webpack_public_path__ + "static/media/login-background.min.278b32e3.png";